import AdminClient from '../client/AdminClient';
import _ from "lodash";
import {mapIds} from "../../../helpers/utils";

class ContactService {
    static async index(session, params) {
        const filterParams = this.parsedContactFilterParams(params.filterParams);
        return AdminClient.get(`/v1/admin/contacts`, session,
            {
                ...params,
                filterParams: filterParams,
            }
        );
    }

    static async new(session) {
        return AdminClient.get(`/v1/admin/contacts/new`, session);
    }

    static async create(session, params) {
        return AdminClient.post(`/v1/admin/contacts/`, session, this.parsedContact(params));
    }

    static async update(contactId, session, params) {
        return AdminClient.put(`/v1/admin/contacts/${contactId}`, session, this.parsedContact(params));
    }

    static async edit(contactId, session) {
        return AdminClient.get(`/v1/admin/contacts/${contactId}/edit`, session);
    }

    static async findMatch(params, session) {
        return AdminClient.get(`/v1/admin/contacts/find_match`, session, params);
    }

    static async riaWorks(params, session) {
        return AdminClient.get(`/v1/admin/contacts/ria_works`, session, params);
    }

    static async getPotentialLinkedinUrl(contactId, session) {
        return AdminClient.get(`/v1/admin/contacts/${contactId}/get_potential_linkedin_url`, session);
    }

    static async show(contactId, session) {
        return AdminClient.get(`/v1/admin/contacts/${contactId}`, session);
    }

    static async delete(contactId, session) {
        return AdminClient.delete(`/v1/admin/contacts/${contactId}`, session);
    }

    static async changeLog(contactId, session) {
        return AdminClient.get(`/v1/admin/contacts/${contactId}/change_log`, session);
    }

    static async notes(contactId, session) {
        return AdminClient.get(`/v1/admin/contacts/${contactId}/notes`, session);
    }

    static async uploadAvatar(contactId, session, file) {
        const formData = new FormData();
        formData.append('avatar', file);
        return AdminClient.uploadFile(`/v1/admin/contacts/${contactId}/upload_avatar`, session, formData);
    }

    static async extraData(session) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session);
    }

    static async investors(session, dataType) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session, {entity: 'Investor', dataType});
    }

    static async titles(session) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session, {entity: 'Title'});
    }

    static async universities(session) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session, {entity: 'University'});
    }

    static async companies(session) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session, {entity: 'Company'});
    }


    static async responsibilities(session) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session, {entity: 'ContactResponsibility'});
    }

    static async expertises(session) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session, {entity: 'FoundationAssetClassExpertise'});
    }

    static async researchers(session) {
        return AdminClient.get(`/v1/admin/contacts/extra_data`, session, {entity: 'AdminUser'});
    }

    static async moveToInvestor(contactId, session, investorId) {
        return AdminClient.put(`/v1/admin/contacts/${contactId}/move_to_investor`, session, {id: contactId, investor_id: investorId});
    }

    static async noLongerWithFirm(contactId, session) {
        return AdminClient.put(`/v1/admin/contacts/${contactId}/no_longer_with_firm`, session);
    }

    static async approveMove(contactId, session) {
        return AdminClient.put(`/v1/admin/contacts/${contactId}/approve_move_to_firm`, session);
    }

    static async markAsReviewed(contactId, session) {
        return AdminClient.put(`/v1/admin/contacts/${contactId}/mark_as_reviewed`, session);
    }

    static async regenerateAiBio(contactId, session) {
        return AdminClient.put(`/v1/admin/contacts/${contactId}/regenerate_ai_bio`, session);
    }

    static parsedContact(contact) {
        return {
            ...contact,
            universities_ids: contact.universities?.map(({university_id}) => (university_id)),
            person_universities_attributes: contact.universities?.map(({id, university_id, start_year, end_year, _destroy}) => ({
                id,
                university_id,
                start_year,
                end_year,
                _destroy
            })),
            companies_ids: contact.companies?.map(({display_id}) => (display_id)),
            company_contacts_attributes: contact.companies?.map(({id, display_id, start_year, end_year, _destroy}) => ({
                id,
                display_id,
                start_date: start_year ? `${start_year}-01-01` : start_year,
                end_date: end_year ? `${end_year}-01-01` : end_year,
                _destroy
            })),
            contact_responsibilities_ids: contact.responsibilities?.map(responsibility => responsibility.id),
            achievement_ids: contact.achievements?.map(({id}) => (id))
        };
    }

    static parsedContactFilterParams(params) {
        if (!_.isEmpty(params)) {
            return {
                ...params,
                researchers: mapIds(params.researchers),
                investors: mapIds(params.investors),
                genders: mapIds(params.genders),
                titles: mapIds(params.titles),
                companies: mapIds(params.companies),
                universities: mapIds(params.universities),
            }
        } else {
            return params;
        }
    }
}

export default ContactService;